<template>
  <main-layout>
    <div class="kzevb">
      <div class="kzevb__menu">
        <router-link to="/kzevb/orders/" active-class="a-active">
          Bestellungen
        </router-link>

        <router-link to="/kzevb/whatsapp/" active-class="a-active">
          WhatsApp
          <span class="whatsapp-menu-count">{{ whatsappUnreadCount }}</span>
        </router-link>

        <router-link to="/kzevb/whatsapp-settings/" active-class="a-active">
          WhatsApp Einstellungen
        </router-link>

        <router-link to="/kzevb/prices/" active-class="a-active">
          Preise
        </router-link>

        <router-link to="/kzevb/reseller_statistics/" active-class="a-active">
          Abr. Reseller
        </router-link>

        <router-link to="/kzevb/logs/" active-class="a-active">
          Log
        </router-link>

        <router-link to="/kzevb/evb_settings/" active-class="a-active">
          evbworker
        </router-link>

        <router-link to="/kzevb/ads/" active-class="a-active">
          Hinweise
        </router-link>

        <router-link to="/kzevb/users/" active-class="a-active">
          Kunden
        </router-link>

        <router-link to="/kzevb/templates/" active-class="a-active">
          Templates
        </router-link>

        <router-link to="/kzevb/site_content/" active-class="a-active">
          Übersetzungen
        </router-link>

        <router-link to="/kzevb/resellers/" active-class="a-active">
          Resellers
        </router-link>

        <router-link to="/kzevb/csv/" active-class="a-active">
          CSV
        </router-link>

      </div>
      <div class="kzevb__body">
        <router-view></router-view>
      </div>
    </div>
  </main-layout>
</template>

<script>
import MainLayout from "@/layouts/main-layout"
import {makeJsonRequest} from "@/plugins/transport"

export default {
  name: "kzevb-layout",
  components: {MainLayout},
  data: () => ({whatsappUnreadCount: 0, whatsappUnreadInterval: null}),
  mounted () {
    this.refreshWhatsappUnreadCount()
    this.whatsappUnreadInterval = window.setInterval(this.refreshWhatsappUnreadCount, 15000)
    window.addEventListener("whatsapp-pending-updated", this.refreshWhatsappUnreadCount)
  },
  beforeDestroy () {
    window.clearInterval(this.whatsappUnreadInterval)
    window.removeEventListener("whatsapp-pending-updated", this.refreshWhatsappUnreadCount)
  },
  methods: {
    async refreshWhatsappUnreadCount () {
      try {
        const response = await makeJsonRequest({
          url: "/call_method/", method: "POST",
          data: {service_name: "whatsapp", method_name: "get_unread_count", arguments: []}
        })
        const payload = await response.json()
        this.whatsappUnreadCount = payload.status === "ok"
          ? Number(payload.result && payload.result.count) || 0
          : 0
      } catch (error) {
        this.whatsappUnreadCount = 0
      }
    }
  }
}
</script>

<style lang="stylus">
.kzevb
  &__menu
    background-color #7EB51E
    padding 3px 0 2px 0

    a
      color #fefefe
      margin 0 10px 0 5px
      font-size 1.1em

.whatsapp-menu-count
  display inline-flex
  align-items center
  justify-content center
  min-width 18px
  height 18px
  margin-left 5px
  padding 0 5px
  border-radius 9px
  background #d71920
  color #fff
  font-size 12px
  font-weight bold
  line-height 18px
</style>
